import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { Password } from "primereact/password";
import PrimaryButton from "../../shared/Button/PrimaryButton";
import { resetSubAdminPassword } from "../../redux/actions/subAdminAction";

export default function ResetSubAdminPassword() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { id } = useParams();
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [errors, setErrors] = useState({});

    const submit = (event) => {
        event.preventDefault();
        const nextErrors = {};

        if (newPassword.length < 8) nextErrors.newPassword = "Password must be at least 8 characters";
        if (newPassword !== confirmPassword) nextErrors.confirmPassword = "Passwords do not match";

        setErrors(nextErrors);
        if (Object.keys(nextErrors).length) return;

        dispatch(resetSubAdminPassword(id, newPassword, () => navigate("/sub-admin")));
    };

    return (
        <div className="col-12">
            <div className="card">
                <div className="flex justify-content-between align-items-center mb-4">
                    <h5 className="m-0">Reset Sub-admin Password</h5>
                    <PrimaryButton label="Back" className="p-button-outlined" onClick={() => navigate("/sub-admin")} />
                </div>

                <form onSubmit={submit}>
                    <div className="grid">
                        <div className="col-12 md:col-6">
                            <label className="block mb-2" htmlFor="new-sub-admin-password">New Password</label>
                            <Password
                                id="new-sub-admin-password"
                                value={newPassword}
                                onChange={(event) => setNewPassword(event.target.value)}
                                toggleMask
                                feedback={false}
                                className="w-full"
                                inputClassName="w-full"
                            />
                            {errors.newPassword && <small className="p-error block mt-1">{errors.newPassword}</small>}
                        </div>
                        <div className="col-12 md:col-6">
                            <label className="block mb-2" htmlFor="confirm-sub-admin-password">Confirm New Password</label>
                            <Password
                                id="confirm-sub-admin-password"
                                value={confirmPassword}
                                onChange={(event) => setConfirmPassword(event.target.value)}
                                toggleMask
                                feedback={false}
                                className="w-full"
                                inputClassName="w-full"
                            />
                            {errors.confirmPassword && <small className="p-error block mt-1">{errors.confirmPassword}</small>}
                        </div>
                    </div>

                    <div className="flex justify-content-end mt-4">
                        <PrimaryButton type="submit" label="Reset Password" />
                    </div>
                </form>
            </div>
        </div>
    );
}
